import { useAnalytics } from '@contexts/AnalyticsContext'
import {
  FetchMembershipAnalyticsGraphParams,
  MembershipAnalyticsGraphOnboardingFunnel,
} from '@models/membership/MembershipAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { Card, Spin, Typography } from 'antd'
import { useEffect, useState } from 'react'
import {
  Funnel,
  FunnelChart,
  LabelList,
  ResponsiveContainer,
  Tooltip,
} from 'recharts'
import CustomTooltip from '../common/CustomTooltip'

const { Text } = Typography

const OnboardingFunnel = () => {
  const { selectedDates, selectedMembershipPrograms } = useAnalytics()

  const [chartData, setChartData] = useState<
    MembershipAnalyticsGraphOnboardingFunnel[]
  >([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const fetchData = async () => {
    setIsLoading(true)
    setError(undefined)

    if (!selectedDates) {
      setChartData([])
      setError('No data available.')
      setIsLoading(false)
      return
    }

    const fetchParams: FetchMembershipAnalyticsGraphParams = {
      entity: 'membership',
      kind: 'onboarding-funnel',
      startDate: selectedDates[0],
      endDate: selectedDates[1],
      programIds: selectedMembershipPrograms,
    }

    try {
      const { data } =
        await fetchAnalyticsGraph<MembershipAnalyticsGraphOnboardingFunnel[]>(
          fetchParams
        )
      setChartData(data || [])

      if (!data) {
        setError('No data available.')
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      setError('An error occurred while fetching data.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [selectedDates, selectedMembershipPrograms])

  return (
    <Card
      style={{ alignContent: 'center', textAlign: 'center', minHeight: 450 }}
    >
      {isLoading && <Spin />}
      {error && <Text>{error}</Text>}
      {chartData && !isLoading && !error && (
        <ResponsiveContainer width={'100%'} height={450}>
          <FunnelChart>
            <Tooltip
              content={(props) => (
                <CustomTooltip
                  type="funnel"
                  {...props}
                  customLabelFormatter={(payload) => {
                    return payload.label
                  }}
                />
              )}
            />
            <Funnel dataKey="value" data={chartData} isAnimationActive>
              <LabelList
                position="center"
                fill="#fff"
                stroke="none"
                dataKey="name"
              />
            </Funnel>
          </FunnelChart>
        </ResponsiveContainer>
      )}
    </Card>
  )
}

export default OnboardingFunnel
